<script lang="ts" setup>
import type { Alert } from './helper/alert'
import { mdiAlert, mdiCheck } from '@mdi/js'
import { alertQueue } from './helper/alert'

function getIcon(item: Alert) {
  if (item.icon)
    return item.icon
  switch (item.color) {
    case 'success':
      return mdiCheck
    case 'error': case 'warning':
      return mdiAlert
  }
  return undefined
}
</script>

<template>
  <v-snackbar-queue
    v-model="alertQueue"
    location="end"
    rounded
  >
    <template #actions="{ item }">
      <div class="d-flex justify-start">
        <v-icon class="mr-2" size="20" :icon="getIcon(item)" />
      </div>
    </template>
  </v-snackbar-queue>
</template>
